var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-waiting"},[_vm._v("\n    正在登录中，请稍后\n")])}
var staticRenderFns = []

export { render, staticRenderFns }